import React from 'react';
import { connect } from 'react-redux';
import { Accordion } from 'semantic-ui-react';
import NoRows from '@/components/table/NoRows';
import QueryDictionaryAccordion from '../../clauses/containers/QueryClausesAccordions';
import { findQuery } from '../../state/shared';

const CohortQueryAccordion = ({
  code,
  category,
  count,
  queryUUID,
}) => (
  <>
    {count === 0 && (<NoRows icon="table" entity="query" />)}
    {count > 0 && (
      <Accordion styled fluid className="aridhia-query-dictionaries-accordion">
        <QueryDictionaryAccordion code={code} category={category} queryUUID={queryUUID} />
      </Accordion>
    )}
  </>
);

export const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
}, ownProps) => {
  const { query } = findQuery(cohorts, ownProps);

  return {
    count: query.clauses.length,
  };
};

export default connect(mapStateToProps)(CohortQueryAccordion);
